export type PollOptions = {
  intervalMs: number;
  hiddenIntervalMs?: number;
  maxIntervalMs?: number;
};

export const createAdaptivePoller = (
  task: () => Promise<void> | void,
  options: PollOptions
): (() => void) => {
  let timer: number | null = null;
  let stopped = false;
  let failures = 0;

  const clear = () => {
    if (timer !== null) {
      window.clearTimeout(timer);
      timer = null;
    }
  };

  const getInterval = () => {
    const base = document.hidden
      ? (options.hiddenIntervalMs ?? Math.max(options.intervalMs * 3, options.intervalMs))
      : options.intervalMs;
    const backoff = Math.min(base * 2 ** failures, options.maxIntervalMs ?? 60000);
    return backoff;
  };

  const tick = async () => {
    if (stopped) return;
    try {
      await task();
      failures = 0;
    } catch {
      failures += 1;
    } finally {
      if (!stopped) {
        timer = window.setTimeout(() => {
          void tick();
        }, getInterval());
      }
    }
  };

  void tick();

  const handleVisibility = () => {
    clear();
    if (!stopped) {
      timer = window.setTimeout(
        () => {
          void tick();
        },
        document.hidden ? getInterval() : 0
      );
    }
  };

  document.addEventListener('visibilitychange', handleVisibility);

  return () => {
    stopped = true;
    clear();
    document.removeEventListener('visibilitychange', handleVisibility);
  };
};
